export const PUBLIC_PLATFORM_INTRO = {
  pageTitle: "香港學校招標及書面報價資訊平台",
  heading: "Skoltend：香港學校招標及書面報價資訊平台",
  description: "Skoltend 整合香港學校的招標及書面報價資訊，協助供應商按地區、採購類別、關鍵字及截止日期尋找相關商機。你可以先瀏覽公開招標摘要，再按需要選用付費會員服務，查看個別招標的學校身份、詳細說明、聯絡資料及文件。",
  disclaimer: "Skoltend 是獨立資訊平台，並非教育局或個別學校的官方網站。招標要求、截止時間及其後修訂，應以發標學校的最新正式文件為準。",
  metaDescription: "Skoltend 整合香港學校招標及書面報價資訊，支援按地區、類別、關鍵字及截止日期篩選。免費瀏覽公開摘要，付費會員可查看已收錄的學校身份、聯絡資料及文件。投標要求以發標學校正式文件為準。",
  links: [
    { label: "瀏覽招標資訊", path: "/tenders" },
    { label: "閱讀採購指南", path: "/guides" },
    { label: "了解會員計劃", path: "/pricing" },
  ],
} as const;

export function renderPublicPlatformIntro() {
  const escape = (value: string) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const intro = PUBLIC_PLATFORM_INTRO;
  return `<h1>${escape(intro.heading)}</h1><p>${escape(intro.description)}</p><p>${escape(intro.disclaimer)}</p><nav>${intro.links.map(link => `<a href="${link.path}">${escape(link.label)}</a>`).join(" · ")}</nav>`;
}
